// extracted by mini-css-extract-plugin
var _1 = "Uwh3S";
export { _1 as "button" }
